/**
 * Infinite horizontal marquee of items.
 * Items are duplicated to create a seamless loop.
 */
export const Marquee = ({ items = [], dark = false, testId }) => {
  const loop = [...items, ...items];
  return (
    <div className={`marquee ${dark ? "dark" : ""}`} data-testid={testId}>
      <div className="track" aria-hidden="true">
        {loop.map((item, i) => (
          <div key={i} className="item">
            <span>{item}</span>
            <span className="dot" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
